function getEnvConfig(platformData) {
  const DEP_ENV = process.env.REACT_APP_DEP
  const isEnvExist = ['dev', 'test', 'prod'].includes(DEP_ENV)
  const configData = platformData.default

  if (isEnvExist) {
    Object.assign(configData, platformData[DEP_ENV])
  }
  return configData
}

export const checkEnv = () => {
  const DEP_ENV = process.env.REACT_APP_DEP
  if (['dev', 'test'].includes(DEP_ENV)) {
    return 'dev'
  }

  if (DEP_ENV === 'prod') {
    return 'prod'
  }
  return null
}
export default getEnvConfig
